<template>
  <TimeslotDashboardLayout>
    <div class="main-content booking">
      <div>
        <div class="content-div">
          <!--          <div class="my-class-div">-->
          <!--            <h1 class="tab-heading">My Registered Classes</h1>-->
          <!--            <div-->
          <!--                data-w-id="020d2082-0ee4-52e8-26fa-9fc9511d1521"-->
          <!--                @click="openNew"-->
          <!--                style="font-size: 14px;"-->
          <!--                class="button w-button"-->
          <!--            >-->
          <!--              + Register-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="text-block-37" style="margin-top: 20px;">Register for a class with a professional.  All class times-->
          <!--            are based on your selected time zone-->
          <!--            <span class="text-span-2"-->
          <!--            ><strong>{{ customerInfo.customerTimezone }}</strong></span-->
          <!--            >.To update-->
          <!--            <span class="link-6 click-margin" @click="openTime">-->
          <!--                  <strong>Click Here</strong>-->
          <!--                </span></div>-->

          <div class="tap-heading-div">
            <h1 class="tab-heading">My Registered Classes</h1>
            <div class="tab-text">
              <div class="text-block-37">
                Register for a class with a professional. All class times are
                based on your selected time zone
                <span class="text-span-2"
                  ><strong>{{ customerInfo.customerTimezone }}</strong
                  >.</span
                >
                To update
                <span class="link-6 click-margin" @click="openTime"
                  ><strong>Click Here</strong></span
                >
              </div>
            </div>
            <div
              data-w-id="8274d422-67e8-f9a6-ea31-9d3797cc8d20"
              class="timeslot-button new-booking w-button"
              @click="openNew"
            >
              Register
            </div>
          </div>
        </div>
      </div>
      <BaseComponentLoader
        v-if="loader.nonBlockingLoader"
        loaderAlignment="center"
      />
      <div v-else>
        <div class="myclass-empty-state" v-if="userClassesAlt.length === 0">
          <div class="div-block-19">
            <img
              src="@/assets/timeslot-images/myclass.svg"
              loading="lazy"
              alt=""
              class="image-6"
            />
            <div class="text-block-20">Nothing to show here</div>
            <div class="text-block-21">
              You do not have any registered class created yet
            </div>
            <!--        <div class="button-15 button">Register</div>-->
          </div>
        </div>
        <div
          data-current="Tab 1"
          data-easing="ease"
          data-duration-in="300"
          data-duration-out="100"
          class="tabs w-tabs"
          v-else
        >
          <div class="tabs-menu-2 w-tab-menu">
            <a
              data-w-tab="Tab 2"
              :class="
                upcoming
                  ? 'booking-tab w-inline-block w-tab-link w--current'
                  : 'booking-tab w-inline-block w-tab-link'
              "
              @click="openUpcoming"
            >
              <div>Upcoming</div>
            </a>
            <a
              data-w-tab="Tab 3"
              :class="
                past
                  ? 'booking-tab w-inline-block w-tab-link w--current'
                  : 'booking-tab w-inline-block w-tab-link'
              "
              @click="openPast"
            >
              <div>Past</div>
            </a>
          </div>
          <div class="w-tab-content">
            <div
              data-w-tab="Tab 2"
              v-if="upcoming"
              :class="upcoming ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
            >
              <div
                class="myclass-empty-state"
                v-if="upcomingClasses.length === 0"
              >
                <div class="div-block-19">
                  <img
                    src="@/assets/timeslot-images/myclass.svg"
                    loading="lazy"
                    alt=""
                    class="image-6"
                  />
                  <div class="text-block-20">Nothing to show here</div>
                  <div class="text-block-21">
                    You do not have any upcoming class
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  class="bookings-list-wrapper bookings"
                  v-for="(singleClass, index) in upcomingClasses"
                  :key="index"
                >
                  <div class="div-block-24-copy">
                    <div class="booking-heading">
                      <div class="text-block-24">
                        {{ singleClass.groupSessionTopic }}
                      </div>
                    </div>
                    <div class="div-block-22">
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/calendar.svg"
                          alt=""
                          class="image-7"
                        />
                        <div>
                          {{
                            new Date(
                              singleClass.groupSessionStartTime.slice(0, 10)
                            )
                              .toString()
                              .slice(0, 11)
                          }}
                        </div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/calendar.svg"
                          alt=""
                          class="image-8"
                        />
                        <div>
                          {{
                            formatHours(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}:{{
                            formatMinutes(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}
                          {{
                            formatTime(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}
                          -
                          {{
                            formatHours(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}:{{
                            formatMinutes(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}
                          {{
                            formatTime(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}
                        </div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/money.svg"
                          alt=""
                          class="image-9"
                        />
                        <div>${{ singleClass.groupSessionAmount }}</div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/Frame.svg"
                          alt=""
                          class="image-9"
                        />
                        <div>
                          {{ singleClass.groupSessionMaxAttendance }} learners
                        </div>
                      </div>
                    </div>
                    <div
                      class="div-block-25 margin-booking"
                      v-if="upcomingOpen && isSelected === index"
                    >
                      <div class="professional-detail-wrapper">
                        <div class="professional-name-wraper">
                          <div class="text-block-25">Professional:</div>
                          <div class="div-block-26">
                            <div>
                              <img
                                width="45"
                                loading="lazy"
                                :src="
                                  singleClass.professionalDisplayPicture ||
                                    require('@/assets/timeslot-images/profileImg.svg')
                                "
                                alt=""
                                class="image-10"
                              />
                            </div>
                            <div>
                              <div class="text-block-26">
                                {{ singleClass.professionalName }}
                              </div>
                              <div>
                                {{ singleClass.professionalCategory }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="professional-name-wraper">
                          <div class="text-block-25">Meeting Link</div>
                          <div class="div-block-26">
                            <div>
                              <div class="text-block-26">
                                <!--                                <a-->
                                <!--                                  class="meeting-link"-->
                                <!--                                  :href="-->
                                <!--                                    singleClass.groupSessionCustomerMeetingLink-->
                                <!--                                  "-->
                                <!--                                  target="_blank"-->
                                <!--                                >-->
                                <!--                                  {{-->
                                <!--                                    singleClass.groupSessionCustomerMeetingLink-->
                                <!--                                  }}-->
                                <!--                                </a>-->
                                <div
                                  @click="
                                    goToClassMeeting(
                                      singleClass.groupSessionCustomerMeetingLink
                                    )
                                  "
                                  class="class-link"
                                >
                                  {{
                                    singleClass.groupSessionCustomerMeetingLink
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="professional-name-wraper">
                          <div class="text-block-25">
                            Professional’s Timezone
                          </div>
                          <div class="div-block-26">
                            <div>
                              <div class="text-block-26">
                                {{ singleClass.professionalTimezone }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--                        <div class="professional-name-wraper">-->
                        <!--                          <div class="text-block-25">-->
                        <!--                            No of students to be enrolled-->
                        <!--                          </div>-->
                        <!--                          <div class="div-block-26">-->
                        <!--                            <div>-->
                        <!--                              <div class="text-block-26">-->
                        <!--                                {{ singleClass.groupSessionMaxAttendance }}-->
                        <!--                              </div>-->
                        <!--                            </div>-->
                        <!--                          </div>-->
                        <!--                        </div>-->
                        <div class="professional-name-wraper">
                          <div class="text-block-25">Description</div>
                          <div class="div-block-26">
                            <div>
                              <p class="paragraph-2">
                                {{ singleClass.groupSessionDescription }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="div-block-27">
                      <div
                        data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e5"
                        class="button-4 outline w-button"
                        @click="openDetails(index)"
                        v-if="!upcomingOpen || isSelected !== index"
                      >
                        View details
                      </div>
                      <div
                        data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e5"
                        class="button-4 outline w-button"
                        @click="closeDetails(index)"
                        v-if="upcomingOpen && isSelected === index"
                      >
                        Hide details
                      </div>
                      <!--                    <div-->
                      <!--                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e7"-->
                      <!--                      href=""-->
                      <!--                      class="button-4 cancel-copy w-button"-->
                      <!--                    >-->
                      <!--                      Reschedule-->
                      <!--                    </div>-->
                      <!--                  <div-->
                      <!--                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e9"-->
                      <!--                      class="button-4-copy outline w-button"-->
                      <!--                      @click="activateCancel(upcomingBooking.bookingId)"-->
                      <!--                  >-->
                      <!--                    Cancel-->
                      <!--                  </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-w-tab="Tab 3"
              v-if="past"
              :class="past ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
            >
              <div class="myclass-empty-state" v-if="pastClasses.length === 0">
                <div class="div-block-19">
                  <img
                    src="@/assets/timeslot-images/myclass.svg"
                    loading="lazy"
                    alt=""
                    class="image-6"
                  />
                  <div class="text-block-20">Nothing to show here</div>
                  <div class="text-block-21">
                    You do not have any past class
                  </div>
                </div>
              </div>

              <div v-else>
                <div
                  class="bookings-list-wrapper bookings"
                  v-for="(singleClass, index) in pastClasses"
                  :key="index"
                >
                  <div class="div-block-24-copy">
                    <div class="booking-heading">
                      <div class="text-block-24">
                        {{ singleClass.groupSessionTopic }}
                      </div>
                    </div>
                    <div class="div-block-22">
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/calendar.svg"
                          alt=""
                          class="image-7"
                        />
                        <div>
                          {{
                            new Date(
                              singleClass.groupSessionStartTime.slice(0, 10)
                            )
                              .toString()
                              .slice(0, 11)
                          }}
                        </div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/calendar.svg"
                          alt=""
                          class="image-8"
                        />
                        <div>
                          {{
                            formatHours(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}:{{
                            formatMinutes(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}
                          {{
                            formatTime(
                              new Date(singleClass.groupSessionStartTime)
                            )
                          }}
                          -
                          {{
                            formatHours(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}:{{
                            formatMinutes(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}
                          {{
                            formatTime(
                              new Date(singleClass.groupSessionEndTime)
                            )
                          }}
                        </div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/money.svg"
                          alt=""
                          class="image-9"
                        />
                        <div>{{ singleClass.groupSessionAmount }}</div>
                      </div>
                      <div class="div-block-23">
                        <img
                          loading="lazy"
                          src="@/assets/timeslot-images/Frame.svg"
                          alt=""
                          class="image-9"
                        />
                        <div>
                          {{ singleClass.groupSessionMaxAttendance }} learners
                        </div>
                      </div>
                    </div>
                    <div
                      class="div-block-25 margin-booking"
                      v-if="upcomingOpen && isSelected === index"
                    >
                      <div class="professional-detail-wrapper">
                        <div class="professional-name-wraper">
                          <div class="text-block-25">Professional:</div>
                          <div class="div-block-26">
                            <div>
                              <img
                                width="45"
                                loading="lazy"
                                :src="
                                  singleClass.professionalDisplayPicture ||
                                    require('@/assets/timeslot-images/profileImg.svg')
                                "
                                alt=""
                                class="image-10"
                              />
                            </div>
                            <div>
                              <div class="text-block-26">
                                {{ singleClass.professionalName }}
                              </div>
                              <div>
                                {{ singleClass.professionalCategory }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--                      <div class="professional-name-wraper">-->
                        <!--                        <div class="text-block-25">Meeting Link</div>-->
                        <!--                        <div class="div-block-26">-->
                        <!--                          <div>-->
                        <!--                            <div class="text-block-26">-->
                        <!--                              <a-->
                        <!--                                  class="meeting-link"-->
                        <!--                                  :href="singleClass.groupSessionMeetingLink"-->
                        <!--                              >-->
                        <!--                                {{ singleClass.groupSessionMeetingLink }}-->
                        <!--                              </a>-->
                        <!--                            </div>-->
                        <!--                          </div>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                        <div class="professional-name-wraper">
                          <div class="text-block-25">
                            Professional’s TimeZone
                          </div>
                          <div class="div-block-26">
                            <div>
                              <div class="text-block-26">
                                {{ singleClass.professionalTimezone }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="professional-name-wraper">
                          <div class="text-block-25">Topic</div>
                          <div class="div-block-26">
                            <div>
                              <div class="text-block-26">
                                {{ singleClass.groupSessionTopic }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="professional-name-wraper">
                          <div class="text-block-25">Description</div>
                          <div class="div-block-26">
                            <div>
                              <p class="paragraph-2">
                                {{ singleClass.groupSessionDescription }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="div-block-27">
                      <div
                        data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e5"
                        class="button-4 outline w-button"
                        @click="openDetails(index)"
                        v-if="!upcomingOpen || isSelected !== index"
                      >
                        View details
                      </div>
                      <div
                        data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e5"
                        class="button-4 outline w-button"
                        @click="closeDetails(index)"
                        v-if="upcomingOpen && isSelected === index"
                      >
                        Hide details
                      </div>
                      <!--                    <div-->
                      <!--                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e7"-->
                      <!--                      href=""-->
                      <!--                      class="button-4 cancel-copy w-button"-->
                      <!--                    >-->
                      <!--                      Reschedule-->
                      <!--                    </div>-->
                      <!--                  <div-->
                      <!--                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e9"-->
                      <!--                      class="button-4-copy outline w-button"-->
                      <!--                      @click="activateCancel(upcomingBooking.bookingId)"-->
                      <!--                  >-->
                      <!--                    Cancel-->
                      <!--                  </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <UpdateTimezoneModal v-if="time" :cancel="closeTime" />
    <NewBookingModal v-if="book" :cancel="closeNew" />
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import CreateClassModal from "@/components/modal/CreateClassModal";
import ProfRightSideMenu from "@/views/timeslot/ProfRightSideMenu";
import ProfessionalAppNavBar from "@/components/navbar/ProfessionalAppNavBar";
import ProfessionalSidebar from "@/views/timeslot/ProfessionalSidebar";
import GroupSessionRequest from "@/model/requests/GroupSessionRequest";
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import moment from "moment";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import NewBookingModal from "@/components/modal/NewBookingModal";
import UpdateTimezoneModal from "@/components/modal/UpdateTimezoneModal";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
export default {
  name: "CustomerClasses",
  components: {
    BaseComponentLoader,
    TimeslotDashboardLayout,
    NewBookingModal,
    UpdateTimezoneModal
  },
  data() {
    return {
      upcoming: true,
      past: false,
      bar: true,
      cross: false,
      isSelected: null,
      upcomingOpen: false,
      classModal: false,
      customerClassModel: GroupSessionRequest.readByCustomerId,
      time: false,
      book: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      customerClasses: state => state.groupSession.customerGroupSessions,
      customerInfo: state => state.customer.customerInfo,
      userClasses: state => state.groupSession.userGroupSessions,
      userClassesAlt: state => state.groupSession.userGroupSessionsAlt
    }),
    upcomingClasses() {
      return this.userClasses.filter(
        item => item.groupSessionStatus === "UPCOMING"
      );
    },
    pastClasses() {
      return this.userClasses.filter(
        item => item.groupSessionStatus === "PAST"
      );
    },
    ...mapState(["loader"])
  },
  methods: {
    goToClassMeeting(value) {
      window.open(value, "_blank");
    },
    openUpcoming() {
      this.upcoming = true;
      this.past = false;
    },
    openPast() {
      this.upcoming = false;
      this.past = true;
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    openDetails(index) {
      this.isSelected = index;
      this.upcomingOpen = true;
    },
    closeDetails(index) {
      this.isSelected = index;
      this.upcomingOpen = false;
    },
    closeClassModal() {
      this.classModal = false;
    },
    openClassModal() {
      this.classModal = true;
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    },
    openTime() {
      this.time = true;
    },
    closeTime() {
      this.time = false;
    },
    openNew() {
      // this.book = true;
      RouterUtils.changeRouteUrlTo("/discover");
    },
    closeNew() {
      this.book = false;
    }
  },
  mounted() {
    // this.customerClassModel.groupSessionCustomerId = this.userInfo.customerId;
    // StoreUtils.dispatch(
    //   "groupSession/readByCustomerId",
    //   this.customerClassModel
    // );
    StoreUtils.dispatch("groupSession/readUserGroupSessions");
  }
};
</script>

<style scoped>
.margin-booking {
  margin-top: 20px;
}
.class-link {
  width: 46%;
  word-wrap: break-word;
  color: #007bff;
}
.class-link:hover {
  text-decoration: underline;
}
</style>
